import React, { useState, useEffect } from "react";
import api from "../api";
import Swal from "sweetalert2";
import "../css/EnterpriseDetails.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { formatDateToUserTimeZone } from "../utils/formatDate";
import crossIcon from "../assets/icons/crossIcon.png";
import editIcon from "../assets/Images/Edit.png";
import viewIcon from "../assets/Images/View.png";
import changeStatusIcon from "../assets/Images/ChangeStatus.png";
import addIcon from "../assets/Images/AddIcon.png";
import downloadIcon from "../assets/Images/Download.png";
import filterIcon from "../assets/Images/Filter.png";

import { ToastContainer } from "react-toastify";
import {
  showSuccessToast,
  showErrorToast,
  showInfoToast,
} from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import modelIcon from "../assets/icons/ProductIcon.png";
import { branding } from "../utils/branding";
import onlineIcon from "../assets/UserIcons/OnlineMode.svg";
import offlineIcon from "../assets/UserIcons/OfflineModeWhite.svg";
import { useTableSort } from "../hooks/useTableSort";
import { SortableHeader } from "../components/SortableHeader";

const BASE_URL = `${process.env.REACT_APP_API_URL}/models1`;

const ModelManagement = () => {
  const [models, setModels] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    model_name: "",
    model_id: "",
    model_icon: null,
    model_generic_name: "",
    model_description: "",
    model_user_description: "",
    model_industry: "",
    model_downloads: "",
    model_likes: "",
    model_parameter: "",
    model_type: "Online", // ✅ Add this default value
    model_path: "", // ⭐ ADD THIS
  });
  const [editingModelId, setEditingModelId] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [downloadingModelId, setDownloadingModelId] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState({});
  const [viewMode, setViewMode] = useState(false);
  const [totalEntries, setTotalEntries] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedModel, setSelectedModel] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [downloadFilter, setDownloadFilter] = useState("");
  // "" = All, "downloaded", "not_downloaded"

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const modelTypeIcon = {
    online: onlineIcon,
    offline: offlineIcon,
  };

  const fetchModels = async () => {
    try {
      const res = await api.get(
        `${BASE_URL}/all?page=${currentPage}&limit=${entriesPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setModels(res.data.data); // model list
      console.log(res.data.data);
      setTotalEntries(res.data.totalCount); // total matching count
    } catch (error) {
      console.error("Error fetching models:", error);
    }
  };

  const [modelsStats, setModelsStats] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    in_review: 0,
  });

  // Product stats list for dashboard
  const modelsStatsList = [
    { label: "Total Models", key: "total", icon: modelIcon },
    { label: "Active Models", key: "active", icon: modelIcon },
    { label: "Inactive Models", key: "inactive", icon: modelIcon },
    { label: "Models in Reviews", key: "in_review", icon: modelIcon },
  ];

  const fetchModelStats = async () => {
    if (!token) throw new Error("No auth token found");
    try {
      const response = await api.get(`${BASE_URL}/status-summary`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModelsStats(response.data);
    } catch (error) {
      console.error("Failed to fetch model stats", error);
    }
  };

  useEffect(() => {
    fetchModels();
    fetchModelStats();
  }, [searchTerm, currentPage, entriesPerPage]);

  const handleReset = () => {
    setSortOrder("asc");
    setDayFilter("");
    setDownloadFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const handleApply = () => {
    // console.log("Filter applied");
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [sortOrder, dayFilter, downloadFilter]);

  // const currentData = models;

  // 1️⃣ Download filter
  const filteredByDownload = models.filter((m) => {
    if (downloadFilter === "downloaded") {
      return m.model_download_status === "1";
    }

    if (downloadFilter === "not_downloaded") {
      return m.model_download_status !== "1";
    }

    return true; // All
  });
  // 2️⃣ Day filter
  const filteredByDay = filteredByDownload.filter((m) => {
    if (!dayFilter) return true;

    const modelDate = new Date(m.updated_timestamp);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (dayFilter === "Today") {
      return modelDate.toDateString() === today.toDateString();
    }

    if (dayFilter === "Yesterday") {
      return modelDate.toDateString() === yesterday.toDateString();
    }

    return true;
  });
  // 3️⃣ Sort (asc / desc)
  const sortedData1 = [...filteredByDay].sort((a, b) => {
    const timeA = new Date(a.updated_timestamp).getTime();
    const timeB = new Date(b.updated_timestamp).getTime();

    return sortOrder === "asc" ? timeA - timeB : timeB - timeA;
  });

  // 4️⃣ Pagination
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;

  const currentData = sortedData1.slice(startIndex, endIndex);

  const totalEntrie = sortedData1.length;
  const totalPages = Math.ceil(totalEntrie / entriesPerPage);

  const showingFrom = totalEntrie === 0 ? 0 : startIndex + 1;
  const showingTo = Math.min(endIndex, totalEntrie);

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  // const totalPages = Math.ceil(totalEntries / entriesPerPage);
  // const showingFrom =
  //   totalEntries === 0 ? 0 : (currentPage - 1) * entriesPerPage + 1;
  // const showingTo = Math.min(currentPage * entriesPerPage, totalEntries);

  // const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1); // reset to page 1 on page size change
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleChangeStatus = async (m) => {
    const result = await Swal.fire({
      title: `Change status of "${m.model_name}"?`,
      input: "select",
      inputOptions: {
        "In Review": "In Review",
        Approved: "Approved",
        Rejected: "Rejected",
      },
      inputValue: m.model_status || "In Review",
      showCancelButton: true,
      confirmButtonText: "Update",
    });

    if (!result.isConfirmed || !result.value) return;

    try {
      await api.put(
        `${BASE_URL}/change-status/${m._id}`,
        { model_status: result.value },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      showSuccessToast(TOAST_MESSAGES.MODEL.STATUS_UPDATE_SUCCESS);

      fetchModels();
    } catch (err) {
      console.error(err);
      showErrorToast(TOAST_MESSAGES.MODEL.STATUS_UPDATE_ERROR);
    }
  };

  const handleViewClick = (m) => {
    setFormData({
      model_name: m.model_name || "",
      model_id: m.model_id || "",
      model_icon: null,
      model_generic_name: m.model_generic_name || "",
      model_description: m.model_description || "", // ✅ Add this line
      model_user_description: m.model_user_description || "",
      model_industry: m.model_industry || "",
      model_downloads: m.model_downloads || "",
      model_likes: m.model_likes || "",
      model_parameter: m.model_parameter || "",
      model_type: m.model_type || "Online", // ✅ Added here
      model_path: m.model_path || "", // ⭐ ADD
    });
    setViewMode(true);
    setShowForm(true);
  };

  const handleDownload = async (m) => {
    setDownloadingModelId(m._id);
    setDownloadStatus((prev) => ({ ...prev, [m._id]: "loading" }));

    try {
      const res = await api.post(
        `${BASE_URL}/download/${encodeURIComponent(m.model_path)}`, // ✅ model_path
        { model_path: m.model_path }, // ✅ model_path
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data.success) {
        showSuccessToast(res.data.message);
        fetchModels();
        setDownloadStatus((prev) => ({ ...prev, [m._id]: "success" }));
      } else {
        if (res.data.errorType === "INCOMPLETE_DETAILS") {
          showErrorToast(
            "Unable to download this Model. Please check the details of the Model description.",
          );
        } else {
          showErrorToast(
            "Unable to download this Model. Please try again later.",
          );
        }
        setDownloadStatus((prev) => ({ ...prev, [m._id]: "error" }));
      }
    } catch (err) {
      console.error("❌ Download error:", err);
      showErrorToast("Unable to download this Model. Please try again later.");
      setDownloadStatus((prev) => ({ ...prev, [m._id]: "error" }));
    } finally {
      setDownloadingModelId(null);
    }
  };

  const handleEdit = (m) => {
    setFormData({
      model_name: m.model_name || "",
      model_id: m.model_id || "",
      model_icon: null,
      model_generic_name: m.model_generic_name || "",
      model_user_description: m.model_user_description || "",
      model_description: m.model_description || "", // ⭐ MISSING FIXED
      model_industry: m.model_industry || "",
      model_downloads: m.model_downloads || "",
      model_likes: m.model_likes || "",
      model_parameter: m.model_parameter || "",
      model_type: m.model_type || "Online", // ✅ Added here
      model_path: m.model_path || "", // ⭐ ADD
    });
    setEditingModelId(m._id);
    setShowForm(true);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // ✅ Client-side validation before API call
    if (!formData.model_id.trim()) {
      showErrorToast(TOAST_MESSAGES.MODEL.ID_REQUIRED);
      return;
    }
    if (!formData.model_name.trim()) {
      showErrorToast(TOAST_MESSAGES.MODEL.NAME_REQUIRED);
      return;
    }
    if (!formData.model_generic_name.trim()) {
      showErrorToast(TOAST_MESSAGES.MODEL.GENERIC_NAME_REQUIRED);
      return;
    }
    if (!formData.model_user_description.trim()) {
      showErrorToast(TOAST_MESSAGES.MODEL.DESCRIPTION_REQUIRED);
      return;
    }

    if (!formData.model_path.trim()) {
      showErrorToast("Model Path is required.");
      return;
    }

    // const modelId = formData.model_id?.trim().toLowerCase();
    // const modelName = formData.model_name?.trim().toLowerCase();

    // // ✅ ADD MODE → STRICT VALIDATION
    // if (!editingModelId && modelId == modelName) {
    //   showErrorToast("Model ID and Model Name should not be the same.");
    //   return;
    // }

    // // ✅ UPDATE MODE → ONLY IF USER MAKES THEM SAME
    // if (editingModelId && modelId == modelName) {
    //   showErrorToast(
    //     "While updating, Model ID and Model Name cannot be the same."
    //   );
    //   return;
    // }

    setIsSubmitting(true);

    const payload = new FormData();
    payload.append("model_id", formData.model_id);
    payload.append("model_name", formData.model_name);
    payload.append("model_generic_name", formData.model_generic_name);
    payload.append("model_user_description", formData.model_user_description);
    payload.append("model_description", formData.model_description);
    payload.append("model_industry", formData.model_industry);
    payload.append("model_downloads", formData.model_downloads || 0);
    payload.append("model_likes", formData.model_likes || 0);
    payload.append("model_parameter", formData.model_parameter);
    payload.append("model_type", formData.model_type);
    payload.append("model_path", formData.model_path); // ⭐ ADD

    if (formData.model_icon) {
      payload.append("model_icon", formData.model_icon);
    }

    const url = editingModelId ? `${BASE_URL}/${editingModelId}` : BASE_URL;
    const method = editingModelId ? "put" : "post";

    try {
      const response = await api({
        url,
        method,
        data: payload,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // ✅ Handle duplicate validation from backend if exists
      if (response?.data?.error?.includes("duplicate id")) {
        showErrorToast(TOAST_MESSAGES.MODEL.ID_DUPLICATE);
        return;
      }
      if (response?.data?.error?.includes("duplicate name")) {
        showErrorToast(TOAST_MESSAGES.MODEL.NAME_DUPLICATE);
        return;
      }
      if (response?.data?.error?.includes("duplicate zerobox name")) {
        showErrorToast(TOAST_MESSAGES.MODEL.GENERIC_NAME_DUPLICATE);
        return;
      }

      // ✅ Success Toast
      showSuccessToast(
        editingModelId
          ? TOAST_MESSAGES.MODEL.UPDATE_SUCCESS
          : TOAST_MESSAGES.MODEL.ADD_SUCCESS,
      );

      fetchModels();
      closeModal();
    } catch (err) {
      const backendError = err?.response?.data;

      if (backendError?.errorCode === "DUPLICATE_ID") {
        showErrorToast("This Model ID already exists.");
      } else if (backendError?.errorCode === "DUPLICATE_NAME") {
        showErrorToast("This Model Name already exists.");
      } else {
        showErrorToast(
          editingModelId
            ? TOAST_MESSAGES.MODEL.UPDATE_ERROR
            : TOAST_MESSAGES.MODEL.ADD_ERROR,
        );
      }

      console.error("Error adding/updating model:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => {
    setFormData({
      model_name: "",
      model_id: "",
      model_icon: null,
      model_generic_name: "",
      model_user_description: "",
      model_industry: "",
      model_downloads: "",
      model_likes: "",
      model_parameter: "",
      model_type: "Online", // ✅ Reset here
      model_path: "", // ⭐ ADD
    });
    setShowForm(false);
    setEditingModelId(null);
    setViewMode(false); // <-- Reset view mode here
  };

  const { sortedData, requestSort, sortConfig } = useTableSort(currentData);


  return (
    <div className="mx-2 pt-1  h-100">
      <div className="d-flex flex-wrap gap-3 mb-0 align-items-stretch">
        {modelsStatsList.map((item, index) => (
          <div
            key={index}
            className="dashboard-box p-3 rounded shadow-sm d-flex flex-column justify-content-between"
          >
            <div className="d-flex align-items-center mb-2">
              <img
                src={item.icon}
                alt={item.label}
                style={{
                  width: "22px",
                  height: "22px",
                  marginRight: "8px",
                }}
                className="icon-image1"
              />
              <h6 className="mb-0">{item.label}</h6>
            </div>
            <h2 className="fw-bold">{modelsStats[item.key]}</h2>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold refresh-prompts" style={{ fontSize: "20px" }}>
          Model Management Details
        </span>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={(e) => {
              setEntriesPerPage(+e.target.value);
              setCurrentPage(1);
            }}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        <div className="d-flex align-items-center">
          <div className="custom-search-wrapper me-3">
            <div className="input-group custom-search-group">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search Models"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <div className="">
            <button
              className="icon-button filter-dropdown-toggle action-button"
              data-bs-toggle="dropdown"
              title="Filter"
            >
              <img
                src={filterIcon}
                className="icon-filter icon-image1"
                alt="Filter"
              />
            </button>
            <div
              className="dropdown-menu profile-menu-dropdown p-2"
              style={{ minWidth: "200px" }}
            >
              <h6 className="fw-bold">Time</h6>
              <hr className="mt-1" />
              {["asc", "desc"].map((order) => (
                <div className="form-check" key={order}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="sortOrder"
                    id={order}
                    value={order}
                    checked={sortOrder === order}
                    onChange={() => setSortOrder(order)}
                  />
                  <label className="form-check-label" htmlFor={order}>
                    {order === "asc" ? "Ascending" : "Descending"}
                  </label>
                </div>
              ))}
              <hr className="my-2" />
              <h6 className="fw-bold">By Day</h6>
              <hr className="mt-1" />
              {["Today", "Yesterday", ""].map((day) => (
                <div className="form-check" key={day || "all"}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dayFilter"
                    id={day || "all"}
                    value={day}
                    checked={dayFilter === day}
                    onChange={() => setDayFilter(day)}
                  />
                  <label className="form-check-label" htmlFor={day || "all"}>
                    {day || "All"}
                  </label>
                </div>
              ))}

              <hr className="my-2" />
              <h6 className="fw-bold">Download Status</h6>
              <hr className="mt-1" />

              {[
                { label: "All", value: "" },
                { label: "Downloaded", value: "downloaded" },
                { label: "Not Downloaded", value: "not_downloaded" },
              ].map((item) => (
                <div className="form-check" key={item.value || "all"}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="downloadFilter"
                    id={`download-${item.value || "all"}`}
                    value={item.value}
                    checked={downloadFilter === item.value}
                    onChange={() => setDownloadFilter(item.value)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`download-${item.value || "all"}`}
                  >
                    {item.label}
                  </label>
                </div>
              ))}

              <hr className="mt-1" />
              <div className="d-flex justify-content-between mt-3">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn bg-dark text-white btn-sm"
                  onClick={handleApply}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>

          <button
            className="btn btn-outline-secondary action-button text-dark"
            onClick={() => setShowForm(true)}
            title="Add Model"
          >
            <img src={addIcon} alt="Add" className="icon-image1" />
          </button>
        </div>
      </div>

      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="refresh-prompts ak-text-md">No entries found.</p>
        </div>
      ) : (
        <div className="not-disable">
          <div className="table-responsive">
            <table className="table m-table table-sm w-100">
              <thead>
                <tr>
                  <th>Icon</th>
                  {/* <th>Model ID</th> */}
                  <SortableHeader
                    column="model_generic_name"
                    label="Model Name"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  {/* <th>Generic Name</th> */}

                  <th>User Description</th>
                  <SortableHeader
                    column="model_industry"
                    label="Industry"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  {/* <th>Downloads</th> */}
                  {/* <th>Likes</th> */}
                  <SortableHeader
                    column="model_parameter"
                    label="Parameters"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  <SortableHeader
                    column="server_status"
                    label="Server Status"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  <SortableHeader
                    column="model_status"
                    label="Approval Status"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  <SortableHeader
                    column="updated_timestamp"
                    label="Updated At"
                    sortConfig={sortConfig}
                    onSort={requestSort}
                  />
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((m) => (
                  <tr key={m._id}>
                    {/* <td>
                      {m.model_icon && m.model_icon.startsWith("uploads/") ? (
                        <img
                          src={`${process.env.REACT_APP_SERVER_URL}/${m.model_icon}`}
                          alt="Icon"
                          style={{
                            width: "25px",
                            height: "25px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <div
                          className="circle-avatar"
                        >
                         {m.model_generic_name?.charAt(0).toUpperCase() || "U"} 
                          {m.model_generic_name?.charAt(0)?.toUpperCase() || "U"}
                        </div>
                      )}
                    </td> */}

                    <td>
                      {m.model_icon &&
                      (m.model_icon.startsWith("uploads/") ||
                        m.model_icon.startsWith("http")) ? (
                        <img
                          src={
                            m.model_icon.startsWith("http")
                              ? m.model_icon
                              : `${process.env.REACT_APP_SERVER_URL}/${m.model_icon}`
                          }
                          alt={m.model_generic_name || "Icon"}
                          onError={(e) => {
                            // If image fails to load, replace it with fallback circle
                            e.target.onerror = null;
                            e.target.replaceWith(
                              Object.assign(document.createElement("div"), {
                                className: "circle-avatar",
                                textContent:
                                  m.model_generic_name
                                    ?.charAt(0)
                                    ?.toUpperCase() || "U",
                              }),
                            );
                          }}
                          style={{
                            width: "25px",
                            height: "25px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <div className="circle-avatar">
                          {m.model_generic_name?.charAt(0)?.toUpperCase() ||
                            "U"}
                        </div>
                      )}
                    </td>

                    {/* <td>{m.model_id}</td> */}
                    {/* <td>{m.model_name}</td> */}
                    <td
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   // gap: "6px",
                    // }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        {m.model_type?.toLowerCase().trim() === "online" ? (
                          <img
                            src={onlineIcon}
                            alt="online"
                            width={14}
                            height={14}
                            title="online model"
                            className="icon-image"
                          />
                        ) : m.model_type?.toLowerCase().trim() === "offline" ? (
                          <img
                            src={offlineIcon}
                            alt="offline"
                            width={14}
                            height={14}
                            title="offline model"
                            style={{
                              opacity: 0.7,
                              filter: "grayscale(100%) brightness(0.25)",
                            }}
                          />
                        ) : null}

                        {m.model_generic_name
                          ? m.model_generic_name.charAt(0).toUpperCase() +
                            m.model_generic_name.slice(1)
                          : "—"}
                      </div>
                    </td>

                    <td title={m.model_user_description}>
                      {m.model_user_description
                        ? m.model_user_description.charAt(0).toUpperCase() +
                          m.model_user_description.slice(1)
                        : "—"}
                    </td>
                    <td>{m.model_industry || "—"}</td>
                    {/* <td>{m.model_downloads || 0}</td> */}
                    {/* <td>{m.model_likes || 0}</td> */}
                    <td>{m.model_parameter || "—"}</td>
                    <td
                      style={{
                        color: m.server_status ? "green" : "red",
                        fontWeight: "600",
                      }}
                    >
                      {m.server_status ? "Present" : "Absent"}
                    </td>
                    <td>{m.model_status || "—"}</td>

                    <td>{formatDateToUserTimeZone(m.updated_timestamp)}</td>
                    <td>
                      <button
                        className="icon-button"
                        onClick={() => handleViewClick(m)}
                        title="View"
                      >
                        <img
                          src={viewIcon}
                          className="icon-image"
                          alt="View"
                          style={{ height: "16px", width: "18px" }}
                        />
                      </button>
                      <button
                        className="icon-button"
                        onClick={() => handleEdit(m)}
                        title="Edit"
                      >
                        <img src={editIcon} className="icon-image" alt="Edit" />
                      </button>
                      <button
                        className="icon-button"
                        title={
                          !m.server_status
                            ? "Server is absent. Status change disabled."
                            : "Change Status"
                        }
                        disabled={!m.server_status}
                        onClick={() => {
                          if (!m.server_status) return; // extra safety
                          setSelectedModel(m);
                          setNewStatus(m.model_status || "In Review");
                          setShowStatusModal(true);
                        }}
                        style={{
                          opacity: !m.server_status ? 0.4 : 1,
                          cursor: !m.server_status ? "not-allowed" : "pointer",
                          pointerEvents: !m.server_status ? "none" : "auto",
                        }}
                      >
                        <img
                          src={changeStatusIcon}
                          className="icon-image"
                          alt="Change Status"
                          style={{
                            filter: !m.server_status
                              ? "grayscale(100%) brightness(0.7)"
                              : "none",
                          }}
                        />
                      </button>

                      <button
                        className="icon-button"
                        onClick={() => handleDownload(m)}
                        title="Download"
                      >
                        {downloadingModelId === m._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : m.model_download_status === "1" ? (
                          <i className="bi bi-check-circle-fill text-success"></i>
                        ) : downloadStatus[m._id] === "error" ? (
                          <i className="bi bi-arrow-clockwise text-danger"></i> // Retry icon
                        ) : (
                          <img
                            src={downloadIcon}
                            className="icon-image"
                            alt="Download"
                          />
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {/* <div className="d-flex justify-content-between align-items-center mt-2 table-footer"> */}
          <div className="table-footer bgcolor fixed-bottom-footer d-flex justify-content-between align-items-center">
            <div className="refresh-prompts">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <nav>
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    <i className="bi bi-chevron-double-left"></i>
                  </button>
                </li>
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(currentPage - 1)}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

                {pageNumbers.map((num) => (
                  <li
                    key={num}
                    className={`page-item ${
                      num === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageClick(num)}
                    >
                      {num}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(currentPage + 1)}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    <i className="bi bi-chevron-double-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      {showForm && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content w-75 mx-auto">
              <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                <div className="modal-header justify-content-center position-relative">
                  <h5 className="modal-title m-0">
                    {viewMode
                      ? "View Model"
                      : editingModelId
                        ? "Edit Model"
                        : "Add Model"}
                  </h5>
                  <button
                    type="button"
                    className="modal-close-btn"
                    onClick={closeModal}
                  >
                    <img src={crossIcon} className="icon-image" alt="Close" />
                  </button>
                </div>

                <div className="modal-body">
                  {/* ================= Row 1 ================= */}
                  <div className="mb-3 d-flex gap-2">
                    <div className="flex-grow-1">
                      <label className="form-label required-label">
                        Model ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.model_id}
                        onChange={(e) =>
                          setFormData({ ...formData, model_id: e.target.value })
                        }
                        required
                        disabled={viewMode}
                      />
                    </div>

                    <div className="flex-grow-1">
                      <label className="form-label required-label">
                        Model Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.model_name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_name: e.target.value,
                          })
                        }
                        required
                        disabled={viewMode}
                      />
                    </div>

                    <div className="flex-grow-1">
                      <label className="form-label required-label">
                        Parameter
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.model_parameter}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_parameter: e.target.value,
                          })
                        }
                        required
                        disabled={viewMode}
                      />
                    </div>
                  </div>

                  {/* ================= Row 2 ================= */}
                  <div className="mb-3 d-flex gap-2">
                    <div className="flex-grow-1">
                      <label className="form-label required-label">
                        {branding("Zerobox Model Name")}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.model_generic_name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_generic_name: e.target.value,
                          })
                        }
                        required
                        disabled={viewMode}
                      />
                    </div>

                    <div className="flex-grow-1">
                      <label className="form-label required-label">
                        Industry
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.model_industry}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_industry: e.target.value,
                          })
                        }
                        required
                        disabled={viewMode}
                      />
                    </div>

                    <div className="flex-grow-1">
                      <label className="form-label">Downloads</label>
                      <input
                        type="number"
                        className="form-control"
                        value={formData.model_downloads}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_downloads: e.target.value,
                          })
                        }
                        disabled={viewMode}
                      />
                    </div>
                  </div>

                  {/* ================= Row 3 ================= */}
                  <div className="mb-3 d-flex gap-2">
                    <div style={{ flex: 1 }}>
                      <label className="form-label">Likes</label>
                      <input
                        type="number"
                        className="form-control"
                        value={formData.model_likes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_likes: e.target.value,
                          })
                        }
                        disabled={viewMode}
                      />
                    </div>

                    <div style={{ flex: 1 }}>
                      <label className="form-label required-label">
                        Model Type
                      </label>
                      <select
                        className="form-select"
                        value={formData.model_type}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_type: e.target.value,
                          })
                        }
                        required
                        disabled={viewMode}
                      >
                        <option value="">Select Model Type</option>
                        <option value="Online">Online</option>
                        <option value="Offline">Offline</option>
                      </select>
                    </div>

                    <div style={{ flex: 1 }}>
                      <label className="form-label">Model Icon</label>
                      <input
                        type="file"
                        className="file-input-reverse"
                        accept="image/*"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            model_icon: e.target.files[0],
                          })
                        }
                        disabled={viewMode}
                      />
                    </div>
                  </div>

                  {/* ================= ⭐ NEW Row: Model Path ================= */}
                  <div className="mb-3">
                    <label className="form-label required-label">
                      Model Path
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="repo_name/model_id/"
                      value={formData.model_path || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          model_path: e.target.value,
                        })
                      }
                      required
                      disabled={viewMode}
                    />
                  </div>

                  {/* ================= Descriptions ================= */}
                  <div className="mb-3">
                    <label className="form-label required-label">
                      User Description
                    </label>
                    <textarea
                      className="input-textarea1 p-1"
                      rows={2}
                      value={formData.model_user_description}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          model_user_description: e.target.value,
                        })
                      }
                      required
                      disabled={viewMode}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label required-label">
                      Model Description
                    </label>
                    <textarea
                      className="input-textarea1 p-1"
                      value={formData.model_description}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          model_description: e.target.value,
                        })
                      }
                      readOnly={viewMode || editingModelId}
                      style={{
                        height: "120px",
                        resize: "none",
                        background:
                          viewMode || editingModelId ? "#eaf0f6" : "#fff",
                      }}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  {viewMode ? (
                    <button
                      type="button"
                      className="cancle-btn"
                      onClick={closeModal}
                    >
                      Close
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="px-5 rounded custom-btn border-none py-2 fw-bold"
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? editingModelId
                          ? "Updating..."
                          : "Adding..."
                        : editingModelId
                          ? "Update Model"
                          : "Add Model"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showStatusModal && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content w-50 mx-auto">
              {/* ======= Modal Header ======= */}
              <div className="modal-header justify-content-center position-relative">
                <h5 className="modal-title m-0">
                  Change Status of "{selectedModel?.model_name}"
                </h5>
                <button
                  type="button"
                  className="modal-close-btn"
                  onClick={() => setShowStatusModal(false)}
                >
                  <img src={crossIcon} className="icon-image" alt="Close" />
                </button>
              </div>

              {/* ======= Modal Body ======= */}
              <div className="modal-body">
                <label className="form-label">Select Status</label>
                <select
                  className="form-select"
                  value={newStatus}
                  onChange={(e) => setNewStatus(e.target.value)}
                >
                  <option value="In Review">In Review</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>

              {/* ======= Modal Footer ======= */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancle-btn"
                  onClick={() => setShowStatusModal(false)}
                  disabled={isUpdating}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="custom-btn"
                  disabled={isUpdating}
                  onClick={async () => {
                    if (!selectedModel) return;

                    setIsUpdating(true);
                    try {
                      const res = await api.put(
                        `${BASE_URL}/change-status/${selectedModel._id}`,
                        { model_status: newStatus },
                        {
                          headers: { Authorization: `Bearer ${token}` },
                        },
                      );

                      // ✅ Show specific toast message based on selected status
                      switch (newStatus) {
                        case "Approved":
                          showSuccessToast(
                            TOAST_MESSAGES.MODEL.STATUS_APPROVED,
                          );
                          break;
                        case "Rejected":
                          showErrorToast(TOAST_MESSAGES.MODEL.STATUS_REJECTED);
                          break;
                        case "In Review":
                          showInfoToast(TOAST_MESSAGES.MODEL.STATUS_IN_REVIEW);
                          break;
                        default:
                          showSuccessToast(
                            TOAST_MESSAGES.MODEL.STATUS_UPDATE_SUCCESS,
                          );
                          break;
                      }

                      // ✅ Optional: You can also show res.data.message if backend sends one
                      // showSuccessToast(res.data.message || TOAST_MESSAGES.MODEL.STATUS_UPDATE_SUCCESS);

                      setShowStatusModal(false);
                      fetchModels(); // Refresh list
                    } catch (err) {
                      console.error(err);
                      // ✅ Handle API failure
                      showErrorToast(TOAST_MESSAGES.MODEL.STATUS_UPDATE_FAILED);
                    } finally {
                      setIsUpdating(false);
                    }
                  }}
                >
                  {isUpdating ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelManagement;
